/*!
 * Get the contrasting color for any hex color
 * (c) 2021 Chris Ferdinandi, MIT License, https://gomakethings.com
 * Derived from work by Brian Suda, https://24ways.org/2010/calculating-color-contrast/
 * @param  {String} A hexcolor value
 * @return {String} The contrasting color (black or white)
 */
import {Dimensions, Size} from './types/label-sheet-layout';
import Qty from 'js-quantities';

function getContrast (hexcolor: string) : string {
  // If a leading # is provided, remove it
  if (hexcolor.slice(0, 1) === '#') {
    hexcolor = hexcolor.slice(1);
  }
  // If a three-character hexcode, make six-character
  if (hexcolor.length === 3) {
    hexcolor = hexcolor.split('').map(function (hex) {
      return hex + hex;
    }).join('');
  }
  // Convert to RGB value
  const r = parseInt(hexcolor.substr(0,2),16);
  const g = parseInt(hexcolor.substr(2,2),16);
  const b = parseInt(hexcolor.substr(4,2),16);
  // Get YIQ ratio
  const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
  // Check contrast
  return (yiq >= 128) ? 'black' : 'white';
}

function convertUnitsSize(value: Size, fromUnit: string, toUnit: string): Size {
  return {
    heightInch: Qty(value.heightInch ?? 0, fromUnit).to(toUnit).toPrec(0.01).scalar,
    widthInch: Qty(value.widthInch ?? 0, fromUnit).to(toUnit).toPrec(0.01).scalar
  };
}

function convertUnitsDimensions(value: Dimensions, fromUnit: string, toUnit: string): Dimensions {
  return {
    topInch: Qty(value.topInch ?? 0, fromUnit).to(toUnit).toPrec(0.01).scalar,
    rightInch: Qty(value.rightInch ?? 0, fromUnit).to(toUnit).toPrec(0.01).scalar,
    bottomInch: Qty(value.bottomInch ?? 0, fromUnit).to(toUnit).toPrec(0.01).scalar,
    leftInch: Qty(value.leftInch ?? 0, fromUnit).to(toUnit).toPrec(0.01).scalar,
  };
}

export {getContrast, convertUnitsSize, convertUnitsDimensions};
